import { createAction, createSelector, createSlice } from "@reduxjs/toolkit";

const initialState = {
	apiError: false,
	apiErrorMessage: false,
	confirmZipcode: "",
	deviceId: "",
	loading: false,
	validDevices: [],
	validZipcode: "",
	zipCode: "",
	zipEmail: "",
	bogoOfferId: "",
	bogoDeviceUrl: "",
	isByodZipcode: false,
	deviceListBy: null,
	isColorFilter: false,
	fetchCartByodUpdated: false,
	showByodDqNotify: false,
	brandsList: [],
	newSelectedDevice: "",
	oneTalk: false,
	storeAppointmentInfo: {},
	selectedAppointmentDetails: {},
	salesRepAvailability: {},
	storeScheduleAppoinmentInfo: {},
	storeQueryParams: {},
	bussResponse: {},
	isBogoFlag: false,
	deviceSelectedForExceedginCreditLimit: undefined,
	selectedDeviceForCreditExceeded: undefined,
	pegaRecommendations: [],
	pdpProductDetails: {},
	categoryOpen: false,
	selectedDeviceDetailsSlice: [],
	tradeInValueInfoSlice: {},
	stopNavigateToPlans: false,
	selectedDeviceForCreditExceededNew: [],
	tradeInToggle: false,
	GWJointOfferSelected: false,
	rentalDeviceDetails: [],
	standardDevicesList: [],
	preferredDevicesList: [],
	rentalDeviceSpecsDetails: [],
	addToCartResponseRental: {},
	rentalRetreivecall: false,
	rentalCreditCall: false,
	initiateExccedCreditCall: false,
	checkExceedCreditResult: false,
	gridWallRedirect: false,
	isReduceRentalClicked: false,
	selectedBusProductID: {},
	isRentalDeviceCallCompleted: false,
	plansFirstDevices: [],
	plansFirstAllDevices: [],
	reviewOpenPDP: false,
	isVBCCart: false,
	rentalDeviceInfo: {},
	accessoriesDetails: {},
	ExceedingRentalDevices: [],
	isPackageCompatible: false,
	newDeviceIds: [],
	isFromShoppingCart: false,
	isPlansFirstCategory: false,
	zipcodeFromGW: "",
	deviceLockTogglePDP: false,
	PDPFeatureList: [],
	PDPFeatureLines: [],
	suppressionCustomization: {},
	validateMultiDeviceIdResp: "",
	validateSimAndDeviceCompatResp: "",
	dynamicPromo: {},
	isPOYDFlow: false,
  poydDocuments: [],
  poydBillAmount: null,
  poydBillUploadSuccess: null,
  poydMtnValidationLoading: false,
  poydMtnValidation: null,
  isPOYDFromGridwall: false,
  filterApplied:{}
};

const MobilitySlice = createSlice({
	name: "Mobility",
	initialState,
	reducers: {
		resetMobilitySlice: (state) => {
			return initialState;
		},
		clearComparedDevices: (state) => {
			state["productCompare"]["compareDeviceInfoList"] = [];
		},
		clearValidDevices: (state) => {
			state["validDevices"] = [];
		},
		removeComparedDevice: (state, { payload }) => {
			state["productCompare"]["compareDeviceInfoList"] = state["productCompare"][
				"compareDeviceInfoList"
			].filter((device) => device.deviceId !== payload);
			delete state["compareDevices"][payload];
		},
		setAddToCartResponse: (state, action) => {
			state["addToCartResponse"] = action.payload;
		},
		setAPIError: (state, action) => {
			state["apiError"] = action.payload;
		},
		setAPIErrorMessage: (state, action) => {
			state["apiErrorMessage"] = action.payload;
		},
		setBrandList: (state, action) => {
			state["deviceFilters"]["brandList"] = action.payload;
		},
		setBrandsList: (state, action) => {
			state["brandsList"] = action.payload;
		},
		setCarrierDetailsByDevice: (state, { payload }) => {
			state["carrierDetailsByDevice"] = payload;
		},
		setCategoryName: (state, action) => {
			state["categoryName"] = action.payload;
		},
		setCombinePricingInfo: (state, action) => {
			state["combinepricing"] = action.payload;
		},
		setCompareDevices: (state, action) => {
			state["compareDevices"] = action.payload;
		},
		setPlansFirstDevices: (state, action) => {
			state["plansFirstDevices"] = action.payload;
		},
		setPlansFirstAllDevices: (state, action) => {
			state["plansFirstAllDevices"] = action.payload;
		},
		setConfirmZipcode: (state, action) => {
			state["confirmZipcode"] = action.payload;
		},
		setDeviceFilters: (state, action) => {
			state["deviceFilters"] = action.payload;
		},
		setDeviceId: (state, action) => {
			state["deviceId"] = action.payload;
		},
		setDeviceIdFromTradeIn: (state, action) => {
			state["deviceIdFromTradeIn"] = action.payload;
		  },
		setDeviceName: (state, action) => {
			state["selectedDeviceName"] = action.payload;
		},
		setFlowType: (state, action) => {
			state["flowType"] = action.payload;
		},
		setSelectedTradeIn: (state, action) => {
			state["selectedTradeIn"] = action.payload;
		},
		setGetReviewsResponse: (state, action) => {
			state["getReviews"] = action.payload;
		},
		setReviewOpenPDP:(state,action)=>{
			state["reviewOpenPDP"] = action.payload
		  },
		setGridwallList: (state, action) => {
			state["gridwall"] = action.payload;
		},
		setMetaInfo: (state, action) => {
			state["metaInformation"] = action.payload;
		},
		setPageLoading: (state, action) => {
			state["loading"] = action.payload;
		},
		setPaymentList: (state, action) => {
			state["deviceFilters"]["paymentList"] = action.payload;
		},
		setPlans: (state, { payload }) => {
			state["plans"] = payload;
		},
		setProductCompareResp: (state, action) => {
			state["productCompare"] = action.payload;
		},
		setProductDetail: (state, action) => {
			state["productDetail"] = action.payload;
		},
		setRemoveTradeInDeviceResponse: (state, { payload }) => {
			state["removeTradeInDeviceResponse"] = payload;
		},
		setSelectedSku: (state, action) => {
			state["selectedSku"] = action.payload;
		},
		setSkuData: (state, action) => {
			state["skuData"] = action.payload;
		},
		setSmartphones: (state, action) => {
			state["smartphones"] = action.payload;
		},
		setPdpDeviceDetails: (state, action) => {
			state["pdpProductDetails"] = action.payload;
		},
		setOneTalk: (state, action) => {
			state["oneTalk"] = action.payload;
		},
		setSortBy: (state, action) => {
			state["sortBy"] = action.payload;
		},
		setValidDevices: (state, { payload }) => {
			const validDevices = state.validDevices || [];
			state["validDevices"] = [...validDevices, payload];
		},
		setValidDevicesPlans: (state, { payload }) => {
			state["selectedDevicePlans"] = payload;
		},
		setValidZipcode: (state, action) => {
			state["validZipcode"] = action.payload;
		},
		setZipcode: (state, action) => {
			state["zipCode"] = action.payload;
		},
		setIsByodZipcode: (state, action) => {
			state["isByodZipcode"] = action.payload;
		},
		setBogoOfferId: (state, action) => {
			state["bogoOfferId"] = action.payload;
		},
		setBogoDeviceUrl: (state, action) => {
			state["bogoDeviceUrl"] = action.payload;
		},
		setDeviceListBy: (state, action) => {
			state["deviceListBy"] = action.payload;
		},
		setIsColorFilter: (state, action) => {
			state["isColorFilter"] = action.payload;
		},
		setFetchCartByodUpdated: (state, action) => {
			state["fetchCartByodUpdated"] = action.payload;
		},
		setShowByodDqNotify: (state, action) => {
			state["showByodDqNotify"] = action.payload;
		},
		setNewSelectedDevice: (state, action) => {
			state["newSelectedDevice"] = action.payload;
		},
		setFilterSelected: (state, action) => {
			state["filterApplied"] = action.payload;
		},
		setBussResponse: (state, action) => {
			state["bussResponse"] = action.payload;
		},
		setSelectedBusProductID: (state, action) => {
			state["selectedBusProductID"] = action.payload;
		},
		setAddressEmergencyInfo: (state, action) => {
			state["addressEmergencyInfo"] = action.payload;
		},
		setEmergecyAddressInfo: (state, action) => {
			state["emergecyAddressInfo"] = action.payload;
		},
		setStoreAppointmentInfo: (state, action) => {
			state["storeAppointmentInfo"] = action.payload;
		},
		setSelectedAppointmentDetails: (state, action) => {
			state["selectedAppointmentDetails"] = action.payload;
		},
		setSalesRepAvailability: (state, action) => {
			state["salesRepAvailability"] = action.payload;
		},
		setStoreScheduleAppoinmentInfo: (state, action) => {
			state["storeScheduleAppoinmentInfo"] = action.payload;
		},
		setZipEmail(state, action) {
			state["zipEmail"] = action.payload;
		},
		setStoreQueryParams: (state, action) => {
			state["storeQueryParams"] = action.payload;
		},
		setReviewsForCompareDevices: (state, action) => {
			state["reviewsForCompareDevices"] = action.payload;
		},
		setIsBogoFlag: (state, action) => {
			state["isBogoFlag"] = action.payload;
		},
		replaceDeviceForExceedingcreditLimit: (state, action) => {
			state["deviceSelectedForExceedginCreditLimit"] = action.payload;
		},
		addedDeviceForExceededCredit: (state, action) => {
			state["selectedDeviceForCreditExceeded"] = action.payload;
		},
		addedDeviceForExceededCreditNew: (state, action) => {
			state["selectedDeviceForCreditExceededNew"] = action.payload;
		},
		setPegaRecommendations: (state, action) => {
			state["pegaRecommendations"] = action.payload;
		},
		setDeviceSuggestionResp: (state, action) => {
			state["deviceSuggestionResp"] = action.payload;
		},
		setError: (state, action) => {
			state["apiFail"] = action.payload;
		},
		setCategoryOpen: (state, action) => {
			state["categoryOpen"] = action.payload;
		},
		setSelectedDeviceDetailsSlice: (state, action) => {
			state["selectedDeviceDetailsSlice"] = action.payload;
		},
		setTradeInValueInfoSlice: (state, action) => {
			state["tradeInValueInfoSlice"] = action.payload;
		},
		setStopNavigateToPlans: (state, action) => {
			state["stopNavigateToPlans"] = action.payload;
		},
		replaceDeviceForExceedingcreditLimitNew: (state, action) => {
			state["deviceSelectedForExceedginCreditLimitNew"] = action.payload;
		},
		setAddToCartDisble: (state, action) => {
			state["disableAddToCart"] = action.payload;
		},
		setTradeInToggleValue: (state, action) => {
			state["tradeInToggle"] = action.payload;
		},
		setGWJointOfferSelected: (state, action) => {
			state["GWJointOfferSelected"] = action.payload;
		},
		setBundleOfferSelected: (state, action) => {
			state["bundleOfferSelected"] = action.payload;
		},
		setRentalDeviceDetails: (state, action) => {
			state["rentalDeviceDetails"] = action.payload;
		},
		setStandardDevicesList: (state, action) => {
			state["standardDevicesList"] = action.payload;
		},
		setPreferredDevicesList: (state, action) => {
			state["preferredDevicesList"] = action.payload;
		},
		setRentalDeviceSpecsDetails: (state, action) => {
			state["rentalDeviceSpecsDetails"] = action.payload;
		},
		setAddToCartResponseRental: (state, action) => {
			state["addToCartResponseRental"] = action.payload;
		},
		setRentalRetreivecall: (state, action) => {
			state["rentalRetreivecall"] = action.payload;
		},
		setRentalCreditCall: (state, action) => {
			state["rentalCreditCall"] = action.payload;
		},
		setInitiateExccedCreditCall: (state, action) => {
			state["initiateExccedCreditCall"] = action.payload;
		},
		setCheckExceedCreditResult: (state, action) => {
			state["checkExceedCreditResult"] = action.payload;
		},
		setGridWallRedirect: (state, action) => {
			state["gridWallRedirect"] = action.payload;
		},
		setIsReduceRentalClicked: (state, action) => {
			state["isReduceRentalClicked"] = action.payload;
		},
		setRentalDeviceCallCompleted: (state, action) => {
			state["isRentalDeviceCallCompleted"] = action.payload;
		},
		setIsVBCCart: (state, action) => {
			state["isVBCCart"] = action.payload;
		},
		setRentalDeviceInfo: (state, action) => {
			state["rentalDeviceInfo"] = action.payload;
		},
		setAccessoriesDetails: (state, action) => {
			state["accessoriesDetails"] = action.payload;
		},
		setExceedingRentalDevices: (state, action) => {
			state["ExceedingRentalDevices"] = action.payload;
		},
		setExceedingRentalDisableCtn: (state, action) => {
			state["ExceedingRentalDisableCtn"] = action.payload;
		},
		setNewDeviceIds: (state, action) => {
			state["newDeviceIds"] = action.payload;
		},
		setDeviceEdited: (state, action) => {
			state["deviceEdited"] = action.payload;
		},
		setpackageCompatible: (state, action) => {
			state["isPackageCompatible"] = action.payload;
		},
		setIsFromShoppingCart: (state, action) => {
			state["isFromShoppingCart"] = action.payload;
		},
		setIsPlansFirstCategory: (state, action) => {
			state["isPlansFirstCategory"] = action.payload;
		},
		setZipcodeFromGW: (state, action) => {
			state["zipcodeFromGW"] = action.payload;
		},
		setDeviceLockTogglePDP: (state, action) => {
			state["deviceLockTogglePDP"] = action.payload;
		},
		setSelectdPackForBuss: (state, action) => {
			state["selectedPackForBUSS"] = action.payload;
		},
		setPDPFeatureList: (state, action) => {
			state["PDPFeatureList"] = action.payload;
		},
		setPDPFeatureLines: (state, action) => {
			state["PDPFeatureLines"] = action.payload;
		},
		setGWPackages: (state, action) => {
			state["GWPackages"] = action.payload;
		},
		setDynamicPromo: (state, action) => {
			state["dynamicPromo"] = action.payload;
		},
		setGridwallImageUrl: (state, action) => {
			state["gridwallImageUrl"] = action.payload;
		},
		setPurchaseInfo: (state, action) => {
			state["purchaseInfo"] = action.payload;
		},
		setPagination: (state, action) => {
			state["pagination"] = action.payload;
		},
		setGridwallSelection: (state, action) => {
			state["gridwallSelection"] = action.payload;
		},
		setBuyNowResp: (state, action) => {
			state["buyNowResp"] = action.payload;
		},
		setSuppressionCustomization: (state, action) => {
			state["suppressionCustomization"] = action.payload;
		},
		setValidateMultiDeviceIdResp: (state, action) => {
			state["validateMultiDeviceIdResp"] = action.payload;
		},
		setValidateSimAndDeviceCompatResp: (state, action) => {
			state["validateSimAndDeviceCompatResp"] = action.payload;
		},
		setImeiWithPsimEsimCapable : (state,action)=>{
			state["imeiWithPsimEsimCapable"] = action.payload
		},
		setIsPOYDFlow: (state, action)=>{
      state["isPOYDFlow"] = action.payload
    },
    setPOYDDocuments: (state, action) => {
      state["poydDocuments"] = action.payload;
    },
    setPOYDBillAmount: (state, action) => {
      state["poydBillAmount"] = action.payload;
    },
    setPOYDBillUploadSuccess: (state, action) => {
      state["poydBillUploadSuccess"] = action.payload;
    },
    setPOYDMtnValidation: (state, action) => {
      state["poydMtnValidation"] = action.payload;
    },
    setPOYDMtnValidationLoading: (state, action) => {
      state["poydMtnValidationLoading"] = action.payload;
    },
    setIsPOYDFromGridwall: (state, action) => {
      state["isPOYDFromGridwall"] = action.payload;
    },
	},
});

export const reducer = MobilitySlice.reducer;

export const addToCart = createAction("MobilitySlice/addToCart");
export const addToCartRental = createAction("MobilitySlice/addToCartRental");
export const clearComparedDevicesAct = createAction(
	"MobilitySlice/clearComparedDevicesAct"
);
export const getCarrierDetailsByDevice = createAction(
	"MobilitySlice/getCarrierDetailsByDevice"
);
export const getCombinePricingInfo = createAction(
	"MobilitySlice/getCombinePricingInfo"
);
export const getCompareDevices = createAction(
	"MobilitySlice/getCompareDevices"
);
export const getGridwallList = createAction("MobilitySlice/getGridwallList");
export const getDynamicPromo = createAction("MobilitySlice/getDynamicPromo");
export const getInitPageLoadInfo = createAction(
	"MobilitySlice/getInitPageLoadInfo"
);
export const getMetaInformation = createAction(
	"MobilitySlice/getMetaInformation"
);
export const getPlans = createAction("MobilitySlice/getPlans");
export const getPlansForValiDevices = createAction(
	"MobilitySlice/getPlansForValiDevices"
);
export const getProductDetailPageInfo = createAction(
	"MobilitySlice/getProductDetailPageInfo"
);
export const getReviews = createAction("MobilitySlice/getReviews");
export const getSharedCartSave = createAction(
	"MobilitySlice/getSharedCartSave"
);
export const getSmartphones = createAction("MobilitySlice/getSmartphones");
export const getRentalDeviceDetails = createAction(
	"MobilitySlice/getRentalDeviceDetails"
);
export const getRentalDeviceSpecsDetails = createAction(
	"MobilitySlice/getRentalDeviceSpecsDetails"
);
export const getRentalDeviceAccessoriesInfo = createAction(
	"MobilitySlice/getRentalDeviceAccessoriesInfo"
);
export const getZipcode = createAction("MobilitySlice/getZipcode");
export const removeComparedDevicesAct = createAction(
	"MobilitySlice/removeComparedDevicesAct"
);
export const removeTradeInDevice = createAction(
	"MobilitySlice/removeTradeInDevice"
);
export const updateValidDevices = createAction(
	"MobilitySlice/updateValidDevices"
);
export const validateZipcode = createAction("MobilitySlice/validateZipcode");
export const validateAddress911 = createAction(
	"MobilitySlice/validateAddress911"
);
export const clearCartAndAddToCart = createAction(
	"MobilitySlice/clearCartAndAddToCart"
);
export const uploadBulkIds = createAction("MobilitySlice/uploadBulkIds");
export const getStoreAppointmentDetails = createAction(
	"MobilitySlice/getStoreAppointmentDetails"
);
export const getStoreScheduleAppointmentDetails = createAction(
	"MobilitySlice/getStoreScheduleAppointmentDetails"
);
export const getSalesRepAvailability = createAction(
	"MobilitySlice/getSalesRepAvailability"
);
export const getFeedBack = createAction("MobilitySlice/getFeedBack");
export const getReviewsForComparePage = createAction(
	"MobilitySlice/getReviewsForComparePage"
);
export const getBussProductPlans = createAction(
	"MobilitySlice/getBussProductPlans"
);
export const getGridwallPegaRecommendation = createAction(
	"MobilitySlice/getGridwallPegaRecommendation"
);
export const sendEmailDetails = createAction("MobilitySlice/sendEmailDetails");
export const validateZipAndRetrieveFeatureOnPDP = createAction(
	"MobilitySlice/validateZipAndRetrieveFeatureOnPDP"
);
export const retrieveFeatureOnPDP = createAction(
	"MobilitySlice/retrieveFeatureOnPDP"
);
export const validateZipAndRetrieveFeatureOnBYOD = createAction(
	"MobilitySlice/validateZipAndRetrieveFeatureOnBYOD"
);
export const retrieveFeatureOnBYOD = createAction(
	"MobilitySlice/retrieveFeatureOnBYOD"
);
export const getPurchaseInfo = createAction("MobilitySlice/getPurchaseInfo");
export const getGridwallDeviceList = createAction("MobilitySlice/getGridwallDeviceList");
export const getGridwallPackages = createAction("MobilitySlice/getGridwallPackages");
export const deviceBuyNow = createAction("MobilitySlice/deviceBuyNow");
export const getSuppressionCustomization = createAction("MobilitySlice/getSuppressionCustomization");
export const validateBulkByod = createAction("MobilitySlice/validateBulkByod");

export const uploadPOYDDocument = createAction("MobilitySlice/uploadPOYDDocument");
export const removeAllPOYDDocuments = createAction("MobilitySlice/removeAllPOYDDocuments");
export const validatePOYDMTN = createAction("MobilitySlice/validatePOYDMTN");

export const {
	resetMobilitySlice,
	clearComparedDevices,
	clearValidDevices,
	removeComparedDevice,
	setAddToCartResponse,
	setAEMInfo,
	setAPIError,
	setAPIErrorMessage,
	setCarrierDetailsByDevice,
	setCategoryName,
	setCompareDevices,
	setPlansFirstDevices,
	setCombinePricingInfo,
	setConfirmZipcode,
	setDeviceFilters,
	setDeviceId,
	setDeviceName,
	setFlowType,
	setSelectedTradeIn,
	setGetReviewsResponse,
	setReviewOpenPDP,
	setGridwallList,
	setMetaInfo,
	setPageLoading,
	setPlans,
	setZipEmail,
	setProductCompareResp,
	setProductDetail,
	setRemoveTradeInDeviceResponse,
	setSelectedSku,
	setSkuData,
	setSmartphones,
	setOneTalk,
	setValidDevices,
	setValidDevicesPlans,
	setValidZipcode,
	setZipcode,
	setIsByodZipcode,
	setBogoOfferId,
	setBogoDeviceUrl,
	setDeviceListBy,
	setIsColorFilter,
	setFetchCartByodUpdated,
	setShowByodDqNotify,
	setBrandsList,
	setNewSelectedDevice,
	setFilterSelected,
	setBussResponse,
	setAddressEmergencyInfo,
	setEmergecyAddressInfo,
	setStoreAppointmentInfo,
	setSalesRepAvailability,
	setSelectedAppointmentDetails,
	setStoreScheduleAppoinmentInfo,
	setStoreQueryParams,
	setDeviceIdFromTradeIn,
	setReviewsForCompareDevices,
	setIsBogoFlag,
	replaceDeviceForExceedingcreditLimit,
	addedDeviceForExceededCredit,
	setPegaRecommendations,
	setPdpDeviceDetails,
	setDeviceSuggestionResp,
	setError,
	setCategoryOpen,
	setSelectedDeviceDetailsSlice,
	setTradeInValueInfoSlice,
	setStopNavigateToPlans,
	replaceDeviceForExceedingcreditLimitNew,
	addedDeviceForExceededCreditNew,
	setAddToCartDisble,
	setTradeInToggleValue,
	setGWJointOfferSelected,
	setBundleOfferSelected,
	setRentalDeviceDetails,
	setStandardDevicesList,
	setPreferredDevicesList,
	setRentalDeviceSpecsDetails,
	setAddToCartResponseRental,
	setRentalRetreivecall,
	setRentalCreditCall,
	setInitiateExccedCreditCall,
	setCheckExceedCreditResult,
	setGridWallRedirect,
	setIsReduceRentalClicked,
	setSelectedBusProductID,
	setRentalDeviceCallCompleted,
	setPlansFirstAllDevices,
	setIsVBCCart,
	setRentalDeviceInfo,
	setAccessoriesDetails,
	setExceedingRentalDevices,
	setExceedingRentalDisableCtn,
	setNewDeviceIds,
	setDeviceEdited,
	setpackageCompatible,
	setIsFromShoppingCart,
	setIsPlansFirstCategory,
	setZipcodeFromGW,
	setDeviceLockTogglePDP,
	setSelectdPackForBuss,
	setPDPFeatureList,
	setPDPFeatureLines,
	setGridwallImageUrl,
	setPurchaseInfo,
	setPagination,
	setGWPackages,
	setDynamicPromo,
	setGridwallSelection,
	setBuyNowResp,
	setSuppressionCustomization,
	setValidateMultiDeviceIdResp,
	setValidateSimAndDeviceCompatResp,
	setImeiWithPsimEsimCapable,
	setIsPOYDFlow,
  setPOYDDocuments,
  setPOYDBillAmount,
  setPOYDBillUploadSuccess,
  setPOYDMtnValidation,
  setPOYDMtnValidationLoading,
  setIsPOYDFromGridwall,
} = MobilitySlice.actions;
